type CampaignBrandProps = {
  variant?: 'default' | 'sidebar' | 'compact' | 'loading'
  inverse?: boolean
}

export function CampaignBrand({ variant = 'default', inverse = false }: CampaignBrandProps) {
  const className = [
    'campaign-wordmark',
    `campaign-wordmark--${variant}`,
    inverse ? 'campaign-wordmark--inverse' : '',
  ].filter(Boolean).join(' ')

  return (
    <div className={className} aria-label="Tainá de Paula — Entregas">
      <div className="wordmark-name">
        <small>Tainá</small>
        <strong>de Paula</strong>
        <span>Operação de entregas</span>
      </div>
    </div>
  )
}
